<template>
  <div class="not-found-page">
    <div class="centered">
      <h1>
        <i class="not-found-icon el-icon-warning"></i> Invalid Token
      </h1>
      <p>{{ message }}</p>
      <p>back to login page 
         <router-link :to="{ name: 'Login' }">click here</router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvalidResetLink',
  data() {
    return {
      message: 'The password reset link is invalid or has expired.'
    }
  },
  mounted() {
    const reason = this.$route.query.reason;

    if (reason === 'expired') {
      this.message = 'This password reset link has expired. Please request a new one.';
    } else if (reason === 'invalid') {
      this.message = 'This password reset link is invalid. Please request again.';
    }

  }
}
</script>

<style lang="scss">
.not-found-page {
  .full-page > .content,
  .centered {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .not-found-icon {
    margin-right: 10px;
  }

  .centered {
    display: flex;
    padding-bottom: 150px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;

    h1,
    i {
      font-size: 50px;
    }

    p {
      font-size: 20px;
      text-align: center;
    }
  }
}
</style>
